import React from "react";
import NtSetupResourceList from "../NtSetupResourceList";
import NtSetupResourceCard from "../NtSetupResourceCard";
import NtIvrMenuForm from "../../../extensions/components/NtIvrMenuForm";
import { fetchIvrMenus } from "../../../api/ivr";
import settings from "../../../config/settings";

const fetcher = (domain) =>
  fetchIvrMenus(domain, 1, settings.pageSizeLoad || 50);

const parseItems = (response) =>
  response?.data?.data || response?.data?.ivr_menus || [];

function NtSetupIvrStep() {
  return (
    <NtSetupResourceList
      icon="menu"
      title="IVR menus"
      subtitle="Auto-attendant call trees"
      addLabel="Add IVR menu"
      emptyTitle="No IVR menus yet"
      emptySubtitle={'Build an auto-attendant that greets callers and routes them by digit.'}
      fetcher={fetcher}
      parseItems={parseItems}
      renderItem={(item, index) => (
        <NtSetupResourceCard
          key={item.ivr_menu_uuid || item.id || index}
          badge={item.ivr_menu_extension || item.extension}
          title={item.ivr_menu_name || item.name || "IVR menu"}
          subtitle={
            item.ivr_menu_description ||
            item.description ||
            item.ivr_menu_greet_long
          }
        />
      )}
      renderForm={({ onCancel, onSave }) => (
        <NtIvrMenuForm onCancel={onCancel} onSave={onSave} />
      )}
    />
  );
}

export default NtSetupIvrStep;
